import { render, staticRenderFns } from "./Verkehr.vue?vue&type=template&id=886728ee&"
import script from "./Verkehr.vue?vue&type=script&lang=js&"
export * from "./Verkehr.vue?vue&type=script&lang=js&"
import style0 from "./Verkehr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports